module.exports = __webpack_public_path__ + "static/img/2.faef948.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/2.png
// module id = 2H2a
// module chunks = 0